import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import { allBahasaKey } from "../../queries/Bahasa/useFetchAllBahasa";
import { allRiwayatPekerjaanKey } from "../../queries/RiwayatPekerjaan/useFetchAllRiwayatPekerjaan";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";

export async function removeRiwayatPekerjaan(RIWAYAT_PEKERJAAN_ID: number) {
  const res = await ApiClient.delete(
    `/RemovePekerjaan?RIWAYAT_PEKERJAAN_ID=${RIWAYAT_PEKERJAAN_ID}`
  );
  return res.data[0];
}

export const useRemoveRiwayatPekerjaan = mutationWrapper(
  removeRiwayatPekerjaan,
  {
    onSuccess: () => {
      getQueryClient().invalidateQueries(allRiwayatPekerjaanKey);
    },
  }
);
